import { render, staticRenderFns } from "./DbTree.vue?vue&type=template&id=015fb66a&scoped=true&"
import script from "./DbTree.vue?vue&type=script&lang=ts&"
export * from "./DbTree.vue?vue&type=script&lang=ts&"
import style0 from "./DbTree.vue?vue&type=style&index=0&id=015fb66a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fb66a",
  null
  
)

export default component.exports